module.exports = __webpack_public_path__ + "static/media/niacinsr1.ae3fee5b.jpg";